import { Buildings } from './buildings';

export enum BuildingNotificationIcon {
  FlipCoin = 'flipCoinNotificationIcon',
  Pusher = 'pusherNotificationIcon',
  Seller = 'sellerNotificationIcon'
}

type TBuildingTypeIcon = {
  shadowColor: string;
  borderColor: string;
  gradientFillStops: string[];
  iconAlias: string;
  notificationIcon?: BuildingNotificationIcon[];
};

type TBuildingsTypeIcons = Record<Buildings, TBuildingTypeIcon>;

const buildingsTypeIcons: TBuildingsTypeIcons = {
  [Buildings.Barbershop]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#675360', '#1A1B40'],
    iconAlias: 'icPirateIcon'
  },
  [Buildings.Seller]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#FF7700', '#2B1400'],
    iconAlias: 'cartIcon',
    notificationIcon: [BuildingNotificationIcon.Seller]
  },
  [Buildings.Tavern]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#DDB168', '#874618', '#0C0405'],
    iconAlias: 'selectTokenIcon',
    notificationIcon: [BuildingNotificationIcon.FlipCoin, BuildingNotificationIcon.Pusher]
  },
  [Buildings.BlackSmith]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.CeramicWorkshop]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.GlassWorkshop]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.ClayQuarry]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#9F6B5E', '#060913'],
    iconAlias: 'miningIcon'
  },
  [Buildings.SandQuarry]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#9F6B5E', '#060913'],
    iconAlias: 'miningIcon'
  },
  [Buildings.ToymakerShop]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.Plantation]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#9F6B5E', '#060913'],
    iconAlias: 'miningIcon'
  },
  [Buildings.Warehouse]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#675360', '#1A1B40'],
    iconAlias: 'walletIcon'
  },
  [Buildings.Townhall]: {
    shadowColor: '0xddcead',
    borderColor: '#FFCF26',
    gradientFillStops: ['#EFCB54', '#854D00'],
    iconAlias: 'leaderboardIcon'
  },
  [Buildings.IronOreMine]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#9F6B5E', '#060913'],
    iconAlias: 'miningIcon'
  },
  [Buildings.CoalMine]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#9F6B5E', '#060913'],
    iconAlias: 'miningIcon'
  },
  [Buildings.GoldOreMine]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#9F6B5E', '#060913'],
    iconAlias: 'miningIcon'
  },
  [Buildings.Jewelry]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.GoldOreSmelter]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.IronOreSmelter]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.Sawmill]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.Dock]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#FF7700', '#2B1400'],
    iconAlias: 'cartIcon'
  },
  [Buildings.ConstructionCamp]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.WitchHut]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon'
  },
  [Buildings.Forest]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'expeditionIcon'
  },
  [Buildings.Cave]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'expeditionIcon'
  },
  [Buildings.Dex]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'hammerIcon' // have to change when right icon will be ready
  },
  [Buildings.Manor]: {
    shadowColor: '0xddcead',
    borderColor: '0xffffff',
    gradientFillStops: ['#777C94', '#191A20'],
    iconAlias: 'houseIcon'
  }
};

export default buildingsTypeIcons;
